// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM9.50301 14.5001H6.5V9.50008H9.50302L15.5 5.5V18.5L9.50301 14.5001Z"}}]};

const SystemMessagesFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-messages-filled',
    ref,
    icon: element,
  },
));

SystemMessagesFilledIcon.displayName = 'SystemMessagesFilledIcon';

export default SystemMessagesFilledIcon;
